

export default[
    {
        title:'TRIBAL WELFARE',
        image:"images/home11.jpeg",
    },
    {
        title:'ENVIORNMENTAL CARE',
        image:"images/home12.jpeg",
    },
    {
        title:'AGRICULTURE',
        image:"images/home13.png",
    },
    {
        title:'TRIBAL WELFARE',
        image:"images/home11.jpeg",
    },
    {
        title:'ENVIORNMENTAL CARE',
        image:"images/home12.jpeg",
    },
    {
        title:'AGRICULTURE',
        image:"images/home13.png",
    }
   
]